import * as React from 'react';
export const arrowIncreaseSvg = React.forwardRef(function arrowIncreaseSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15 3.125h-4a.875.875 0 0 0 0 1.75h1.888L9 8.763 6.619 6.38a.875.875 0 0 0-1.238 0l-5 5a.875.875 0 1 0 1.239 1.24L6 8.237l2.381 2.382a.875.875 0 0 0 1.238 0l4.506-4.507V8a.875.875 0 0 0 1.75 0V4A.875.875 0 0 0 15 3.125Z',
    }),
  );
});
arrowIncreaseSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var arrowIncrease = {
  category: 'icon',
  colorable: true,
  name: 'arrowIncrease',
  svg: arrowIncreaseSvg,
};
